<script setup lang="ts">
import type { PropType } from 'vue';

const props = defineProps({
  arrowColor: {
    type: String,
    default: 'content-txt-ttl'
  },
  caption: {
    type: String
  },
  disable: {
    type: Boolean
  },
  hideArrow: {
    type: Boolean,
    default: false
  },
  icon: {
    type: String
  },
  iconSize: {
    type: String,
    default: '18px'
  },
  label: {
    type: String,
    required: true
  },
  to: {
    type: String as PropType<string | object>
  }
});

</script>

<template>
  <q-item clickable
          :disable="props.disable"
          :to="props.to">

    <!--  Icon -->
    <q-item-section v-if="props.icon"
                    avatar
                    class="pr-16">
        <q-icon :name="props.icon"
                :size="props.iconSize" />
    </q-item-section>

    <!-- Label -->
    <q-item-section class="pr-16">
      <q-item-label>{{ props.label }}</q-item-label>
      <q-item-label v-if="props.caption"
                    caption>{{ props.caption }}</q-item-label>
    </q-item-section>

    <!-- CTA Icon -->
    <q-item-section v-if="!hideArrow"
                    side>
      <q-icon :color="arrowColor"
              name="fa-solid fa-angle-right"
              size="24px" />
    </q-item-section>
  </q-item>
</template>

<style scoped lang="scss">
@use 'sass:map';

.q-item {
  $q-item-brdr-block: 1px solid $border-clr;

  color: map.get($co-brand-clrs, content-txt-ttl);
  padding: 0;
  padding-block: 8px;
  border-block-start: $q-item-brdr-block;

  &:last-child { // .q-item
    border-block-end: $q-item-brdr-block;
  }

  // Section
  &__section {
    min-height: 39px;

    &:last-child { // .q-item__section
      width: 24px;
      padding: 0;
      align-items: center;
    }

    // Icon
    &--avatar { // .q-item__section
      align-items: center;
      padding: 0;

      .q-item > & {
        min-width: 18px;
      }
    }
  }

  // Label (text)
  &__label { // <div>
    font-weight: map.get($text-weights, semibold);
  }
}
</style>
